export const EVENTS = {
  KEY_PRESS: 'keypress',
  KEY_DOWN: 'keydown',
  KEY_UP: 'keyup'
}


// WEBPACK FOOTER //
// ./web/js/keyHandlers/constants.js